// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"230":"ckeditor","532":"styles"}[chunkId] + "." + {"230":"5809cab7ac68e42dec80","532":"4b9b5e77b362b8c563ad"}[chunkId] + ".css";
};